// src/components/Dashboard/PlayerDashboard/PlayerExtras/Extras.js
import React from 'react';

const Extras = () => {
    return (
        <div className="player-extras">
            <h2>Extras</h2>
            <p>Additional features or tools will be available here for players.</p>
        </div>
    );
};

export default Extras;
